import { Profile } from '@/ts/store/profile';
import { RouteRecordRaw } from 'vue-router';

export const admins: Array<RouteRecordRaw> = [
  
    // admin
    {path: '/admin',  name: 'admin', beforeEnter: [logged, god], component: () => import('@/page/admin/index.vue'),
      children:[
        
        // dicts
        {path: 'dicts', name: 'admin/dicts', component: () => import('@/page/admin/dicts/index.vue'),
          children:[
            {path: 'skills',  name: 'admin/dicts/skills', component: () => import('@/page/admin/dicts/skills.vue')},          
          ],
        },
        
        // accounts
        {path: 'accounts',  name: 'admin/accounts', component: () => import('@/page/admin/accounts/index.vue'),
          children:[
            // {path: 'skills',  name: 'admin/dicts/skills', component: () => import('@/page/admin/dicts/skills.vue')},          
          ],
        },
        
        // accounts
        {path: 'news',  name: 'admin/news', component: () => import('@/page/admin/news/index.vue'),
          children:[
            // {path: 'skills',  name: 'admin/dicts/skills', component: () => import('@/page/admin/dicts/skills.vue')},          
          ],
        },
  
  
      ],
    },
  
  
]


function logged(to: any, from: any, next: any) {
  console.log('router logged')
  const db = Profile()
  const profile: any = db.profile
  if (profile.id){
    next()
  } else{
    next({ name: 'home' })
  }
}

function god(to: any, from: any, next: any) {
  const db = Profile()  
  if (db.god){
    next()
  } else{
    next({ name: 'home' })
  }
}